import { Link } from "react-router-dom";
import { company } from "@/mocks/site";

interface CtaBandProps {
  title?: string;
  text?: string;
}

export default function CtaBand({
  title = "Sprechen Sie mit uns über Ihr Projekt.",
  text = "Ob Einzelteil, komplette Anlage oder Stellplatz-Ausstattung: Wir prüfen Ihre Anforderung und melden uns mit einer konkreten Lösung.",
}: CtaBandProps) {
  return (
    <section className="relative overflow-hidden bg-primary-500">
      <div className="blueprint absolute inset-0 opacity-30" />
      <div className="relative mx-auto flex w-full max-w-shell flex-col items-start justify-between gap-8 px-4 py-14 md:flex-row md:items-center md:px-6 md:py-16">
        <div className="max-w-2xl">
          <p className="mb-3 font-label text-[11px] uppercase tracking-[0.24em] text-background-50/80">
            Kontakt aufnehmen
          </p>
          <h2 className="font-heading text-[26px] font-extrabold leading-tight tracking-tightest text-background-50 sm:text-[32px] md:text-[38px]">
            {title}
          </h2>
          <p className="mt-4 text-[14px] leading-relaxed text-background-50/85 md:text-[15px]">{text}</p>
        </div>
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-background-50 px-6 py-4 font-heading text-[12px] font-bold uppercase tracking-[0.14em] text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            Anfrage senden
            <i className="ri-arrow-right-line text-[15px]" />
          </Link>
          <a
            href={`tel:${company.phoneHref}`}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-background-50/50 px-6 py-4 font-heading text-[12px] font-bold uppercase tracking-[0.14em] text-background-50 transition-colors hover:border-background-50 hover:bg-background-50/10"
          >
            <i className="ri-phone-line text-[15px]" />
            {company.phone}
          </a>
        </div>
      </div>
    </section>
  );
}